import { createFrontendModule } from '@backstage/frontend-plugin-api';

import {
  AnalyticsApi,
  AppLayout,
  CacheExtension,
  EonTheme,
  IconBundle,
  NavExtensionOverride,
  RedirectRoutes,
  SignInPageExtension,
} from './extensions';

export const appModuleIpen = createFrontendModule({
  extensions: [
    AnalyticsApi,
    AppLayout,
    CacheExtension,
    EonTheme,
    IconBundle,
    NavExtensionOverride,
    ...RedirectRoutes,
    SignInPageExtension,
  ],
  featureFlags: [{ name: 'dev-nav' }],
  pluginId: 'app',
});
